export const getFirebaseOrderColorsPath = (licenseToken: string): string =>
    `${licenseToken}/clientData/orderKeyToDigibonColor`
